import { ID_TYPE } from '.';
import { INVENTORY_TYPE_MAP } from '../options/baseOptions/inventory';
import { INVENTORY_TYPE } from './inventory';


export type AD_FORMAT_RAW_TYPE = {
    no: ID_TYPE;
    width: number;
    height: number;
}

export function AD_FORMAT_KEY(type: INVENTORY_TYPE, width: number, height: number): keyof typeof AD_FORMAT {
    const inventory = INVENTORY_TYPE_MAP[type];
    const key = `${inventory}:${width}x${height}` as keyof typeof AD_FORMAT;
    return key;
}

/* 
* 고객정보조회 시점과 함께 API 호출해 적용하면, 적당히 처리할 수 있을 듯 해보임.
*/
const AD_FORMAT_REFERENCE = {
    banner: {
        ['640x100']  : 3,
        ['300x45']   : 17,
        ['300x250']  : 31,
        ['320x100']  : 32,
        ['320x50']   : 9,
        ['640x200']  : 98,
        ['600x500']  : 122,
    },
    interstitial: {
        ['480x320']    : 1,
        ['500x800']    : 2,
        ['640x960']    : 4,
        ['800x1280']   : 6,
        ['960x640']    : 7,
        ['900x1458']   : 8,
        ['320x480']    : 10,
        ['610x855']    : 12,
        ['768x974']    : 13,
        ['800x1230']   : 14,
        ['640x600']    : 15,
        ['720x1230']   : 16,
        ['300x250']    : 21,
        ['750x1200']   : 28,
    },
    native: {
        ['80x80']      : 23,
        ['128x128']    : 24,
        ['1200x627']   : 25,
        ['1200x628']   : 26,
        ['300x300']    : 109,
        ['400x400']    : 111,
        ['328x152']    : 115,
        ['280x280']    : 116,
        ['560x560']    : 117,
        ['624x328']    : 120,
        ['656x304']    : 121,
        ['615x366']    : 123,
        ['328x140']    : 126,
        ['656x280']    : 129,
        ['680x170']    : 136,
        ['335x415']    : 137,
        ['320x120']    : 140,
        ['640x240']    : 141,
        ['720x436']    : 142,
        ['310x218']    : 143,
        ['640x336']    : 144,
        ['320x192']    : 145,
        ['640x384']    : 149,
        ['320x168']    : 150,
        ['320x268']    : 151,
        ['640x536']    : 152,
        ['750x604']    : 153,
        ['750x260']    : 154,
        ['750x412']    : 155,
        ['1029x258']   : 156,
        ['335x260']    : 157,
        ['335x174']    : 158,
        ['670x348']    : 159,
        ['1200x1200']  : 160,
        ['700x394']    : 161,
        ['840x560']    : 162,
        ['700x524']    : 163,
        ['360x80']     : 164,
        ['720x160']    : 165,
        ['286x172']    : 166,
        ['572x344']    : 167,
        ['320x370']    : 168,
        ['620x512']    : 169,
        ['640x160']    : 170,
        ['640x178']    : 171,
    },
}

export enum AD_FORMAT { // rule : `${INVENTORY_TYPE_MAP 에 따른 라벨}:${width}x${height}` 2 값(width, height)에 의해 결정되다가 3 값(type, width, height)에 의해 결정되는 것으로 전면 수정
    ['Banner:640x100']     = AD_FORMAT_REFERENCE.banner['640x100'],
    ['Banner:300x45']      = AD_FORMAT_REFERENCE.banner['300x45'],
    ['Banner:300x250']     = AD_FORMAT_REFERENCE.banner['300x250'],
    ['Banner:320x100']     = AD_FORMAT_REFERENCE.banner['320x100'],
    ['Banner:320x50']      = AD_FORMAT_REFERENCE.banner['320x50'],
    ['Banner:640x200']     = AD_FORMAT_REFERENCE.banner['640x200'],
    ['Banner:600x500']     = AD_FORMAT_REFERENCE.banner['600x500'],

    ['Interstitial:480x320']   = AD_FORMAT_REFERENCE.interstitial['480x320'],
    ['Interstitial:500x800']   = AD_FORMAT_REFERENCE.interstitial['500x800'],
    ['Interstitial:640x960']   = AD_FORMAT_REFERENCE.interstitial['640x960'],
    ['Interstitial:800x1280']  = AD_FORMAT_REFERENCE.interstitial['800x1280'],
    ['Interstitial:960x640']   = AD_FORMAT_REFERENCE.interstitial['960x640'],
    ['Interstitial:900x1458']  = AD_FORMAT_REFERENCE.interstitial['900x1458'],
    ['Interstitial:320x480']   = AD_FORMAT_REFERENCE.interstitial['320x480'],
    ['Interstitial:610x855']   = AD_FORMAT_REFERENCE.interstitial['610x855'],
    ['Interstitial:768x974']   = AD_FORMAT_REFERENCE.interstitial['768x974'],
    ['Interstitial:800x1230']  = AD_FORMAT_REFERENCE.interstitial['800x1230'],
    ['Interstitial:640x600']   = AD_FORMAT_REFERENCE.interstitial['640x600'],
    ['Interstitial:720x1230']  = AD_FORMAT_REFERENCE.interstitial['720x1230'],
    ['Interstitial:300x250']   = AD_FORMAT_REFERENCE.interstitial['300x250'],
    ['Interstitial:750x1200']  = AD_FORMAT_REFERENCE.interstitial['750x1200'],

    ['Native:80x80']           = AD_FORMAT_REFERENCE.native['80x80'],
    ['Native:128x128']         = AD_FORMAT_REFERENCE.native['128x128'],
    ['Native:1200x627']        = AD_FORMAT_REFERENCE.native['1200x627'],
    ['Native:1200x628']        = AD_FORMAT_REFERENCE.native['1200x628'],
    ['Native:300x300']         = AD_FORMAT_REFERENCE.native['300x300'],
    ['Native:400x400']         = AD_FORMAT_REFERENCE.native['400x400'],
    ['Native:328x152']         = AD_FORMAT_REFERENCE.native['328x152'],
    ['Native:280x280']         = AD_FORMAT_REFERENCE.native['280x280'],
    ['Native:560x560']         = AD_FORMAT_REFERENCE.native['560x560'],
    ['Native:624x328']         = AD_FORMAT_REFERENCE.native['624x328'],
    ['Native:656x304']         = AD_FORMAT_REFERENCE.native['656x304'],
    ['Native:615x366']         = AD_FORMAT_REFERENCE.native['615x366'],
    ['Native:328x140']         = AD_FORMAT_REFERENCE.native['328x140'],
    ['Native:656x280']         = AD_FORMAT_REFERENCE.native['656x280'],
    ['Native:680x170']         = AD_FORMAT_REFERENCE.native['680x170'],
    ['Native:335x415']         = AD_FORMAT_REFERENCE.native['335x415'],
    ['Native:320x120']         = AD_FORMAT_REFERENCE.native['320x120'],
    ['Native:640x240']         = AD_FORMAT_REFERENCE.native['640x240'],
    ['Native:720x436']         = AD_FORMAT_REFERENCE.native['720x436'],
    ['Native:310x218']         = AD_FORMAT_REFERENCE.native['310x218'],
    ['Native:640x336']         = AD_FORMAT_REFERENCE.native['640x336'],
    ['Native:320x192']         = AD_FORMAT_REFERENCE.native['320x192'],
    ['Native:640x384']         = AD_FORMAT_REFERENCE.native['640x384'],
    ['Native:320x168']         = AD_FORMAT_REFERENCE.native['320x168'],
    ['Native:320x268']         = AD_FORMAT_REFERENCE.native['320x268'],
    ['Native:640x536']         = AD_FORMAT_REFERENCE.native['640x536'],
    ['Native:750x604']         = AD_FORMAT_REFERENCE.native['750x604'],
    ['Native:750x260']         = AD_FORMAT_REFERENCE.native['750x260'],
    ['Native:750x412']         = AD_FORMAT_REFERENCE.native['750x412'],
    ['Native:1029x258']        = AD_FORMAT_REFERENCE.native['1029x258'],
    ['Native:335x260']         = AD_FORMAT_REFERENCE.native['335x260'],
    ['Native:335x174']         = AD_FORMAT_REFERENCE.native['335x174'],
    ['Native:670x348']         = AD_FORMAT_REFERENCE.native['670x348'],
    ['Native:1200x1200']       = AD_FORMAT_REFERENCE.native['1200x1200'],
    ['Native:700x394']         = AD_FORMAT_REFERENCE.native['700x394'],
    ['Native:840x560']         = AD_FORMAT_REFERENCE.native['840x560'],
    ['Native:700x524']         = AD_FORMAT_REFERENCE.native['700x524'],
    ['Native:360x80']          = AD_FORMAT_REFERENCE.native['360x80'],
    ['Native:720x160']         = AD_FORMAT_REFERENCE.native['720x160'],
    ['Native:286x172']         = AD_FORMAT_REFERENCE.native['286x172'],
    ['Native:572x344']         = AD_FORMAT_REFERENCE.native['572x344'],
    ['Native:320x370']         = AD_FORMAT_REFERENCE.native['320x370'],
    ['Native:620x512']         = AD_FORMAT_REFERENCE.native['620x512'],
    ['Native:640x160']         = AD_FORMAT_REFERENCE.native['640x160'],
    ['Native:640x178']         = AD_FORMAT_REFERENCE.native['640x178'],
}